/** 
  * @class Resource Class for Font Content
  * @extends SSResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSResource from './00-slideshare_resource'

function SSFontResource(config){
  this.resourceTemplate = {
    prefix: config.baseUrl,
    cacheable: true,
    retries : 2,
    isCritical: false
  };
  SSResource.call(this, config);
}

SSFontResource.prototype = new SSResource();


/** 
  * Configures the resource based on the resourceType
  */
SSFontResource.prototype._initResourceConfig = function(){
  var resourceTemplate = this.resourceTemplate;
  this.url = resourceTemplate.prefix + 'meta-' + this.config.indexString + 
                this.config.suffix + '?' +  this.config.timestamp;
  
  this.cacheable = resourceTemplate.cacheable;
  this.retries = resourceTemplate.retries || 0;
  this.isCritical = resourceTemplate.isCritical;
};

/**
  * @private
  * Tries to load the resource
  */
SSFontResource.prototype._tryLoad = function(){    
  $.jsonp({
    url: this.url,
    callback : 'slideshare_jsonp_font_hook_trigger',
    success : this.resourceLoadedInternalHandler(),
    error : this.resourceErrorInternalHandler(),
    cache : true,
    timeout : 10000
  });
};


/**
  * EventHandler factory for when resource finishes loading successfully
  * @private
  */
SSFontResource.prototype.resourceLoadedInternalHandler = function(){
  var that = this;
  return function foo(data){
    that.status = 'cached';
    $.slideshareEventManager.trigger('fontresourceloaded', {
      style : data.style
    });    
  };
};

/**
  * EventHandler factory for when resource fails to load
  *   Retries this.retries number of times in case of failure before giving up
  * @private
  */
SSFontResource.prototype.resourceErrorInternalHandler = function(){
  var that = this;
  return function(data){
    var startTime = that.startTime;
    var elapsedTime = (new Date()).getTime() - startTime;
    var retries = that.retries;
    
    if (retries > 0 && elapsedTime < that.TIMEOUT_LIMIT){
      retries = retries - 1;
      that.update({retries : retries});
      setTimeout(function(){
        that._tryLoad();
      },1000);
      
    } else {
      $.slideshareEventManager.trigger('fontloadfailed', {});      
    }
  };
};

export default SSFontResource;
